import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';

import MESSENGER_DEFINITIONS from './messengers.js';
import MessengerItem from './MessengerItem';

import styles from './SortableList.scss';

const getMessengerName = (item) => item.messenger;

const SortableItem = SortableElement(({ definition, data, t }) => (
    <MessengerItem definition={definition} data={data} t={t} />
));

function SortableList({ messengers, t, isFetching }) {
    const collectMessengers = (messengers) => {
        const shortHand = (messenger) => messengers.find((x) => x.messenger === messenger);
        const has = messengers.map(getMessengerName);
        const rest = MESSENGER_DEFINITIONS.map(getMessengerName).filter((messenger) => has.indexOf(messenger) < 0);

        return [...has, ...rest]
            .map((messenger) => MESSENGER_DEFINITIONS.find((d) => d.messenger === messenger))
            .filter(Boolean)
            .map((definition) => ({
                definition,
                data: shortHand(definition.messenger),
            }));
    };

    const ordered = collectMessengers(messengers);
    return (
        <ul className={classNames({ [styles.messengersList]: true, [styles.fetching]: isFetching })}>
            {ordered
                .filter(({ data }) => !!data)
                .map(({ data, definition }, index) => (
                    <SortableItem
                        key={definition.messenger}
                        index={index}
                        data={data}
                        definition={definition}
                        t={t}
                        disabled={!data}
                    />
                ))}
            {ordered
                .filter(({ data }) => !data)
                .map(({ data, definition }) => (
                    <MessengerItem key={definition.messenger} definition={definition} data={data} t={t} />
                ))}
        </ul>
    );
}

SortableList.propTypes = {
    messengers: PropTypes.array,
    t: PropTypes.func.isRequired,
    isFetching: PropTypes.bool,
};

export default SortableContainer(SortableList);
